(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["laprima-ecru"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('laprima-ecru-section')) {
  customElements.define('laprima-ecru-section', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click',event => {
        const button=event.target.closest('[data-pc-photo]');
        if(!button) return;
        const n=Number(button.dataset.pcPhoto);
        this.querySelectorAll('.gal .ph').forEach((p,i)=>p.dataset.pcActive=String(i===n));
        this.querySelectorAll('[data-pc-photo]').forEach((b,i)=>b.setAttribute('aria-current',String(i===n)));
      },{signal:this.controller.signal});
      const note=this.querySelector('.lp-evercore-loading');
      this.observer=new MutationObserver(()=>{
        if(this.querySelector('.evcod-embedded')) {note?.remove();this.observer.disconnect();}
      });
      this.observer.observe(this,{childList:true,subtree:true});
      this.timer=setTimeout(()=>{if(note?.isConnected)note.textContent='Le formulaire est indisponible. Contactez LAPRIMA au +216 51 680 901.';},15000);
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laprima-ensemble"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('laprima-product-section')) {
  customElements.define('laprima-product-section', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click',event => {
        const button=event.target.closest('[data-pc-photo]');
        if(!button) return;
        const n=Number(button.dataset.pcPhoto);
        this.querySelectorAll('.gal .ph').forEach((p,i)=>p.dataset.pcActive=String(i===n));
        this.querySelectorAll('[data-pc-photo]').forEach((b,i)=>b.setAttribute('aria-current',String(i===n)));
      },{signal:this.controller.signal});
      const note=this.querySelector('.lp-evercore-loading');
      this.observer=new MutationObserver(()=>{
        if(this.querySelector('.evcod-embedded')) {note?.remove();this.observer.disconnect();}
      });
      this.observer.observe(this,{childList:true,subtree:true});
      this.timer=setTimeout(()=>{if(note?.isConnected)note.textContent='Le formulaire est indisponible. Contactez LAPRIMA au +216 51 680 901.';},15000);
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laprima-nouha"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('laprima-nouha-section')) {
  customElements.define('laprima-nouha-section', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click',event => {
        const button=event.target.closest('[data-pc-photo]');
        if(!button) return;
        const n=Number(button.dataset.pcPhoto);
        this.querySelectorAll('.gal .ph').forEach((p,i)=>p.dataset.pcActive=String(i===n));
        this.querySelectorAll('[data-pc-photo]').forEach((b,i)=>b.setAttribute('aria-current',String(i===n)));
      },{signal:this.controller.signal});
      const note=this.querySelector('.lp-evercore-loading');
      this.observer=new MutationObserver(()=>{
        if(this.querySelector('.evcod-embedded')) {note?.remove();this.observer.disconnect();}
      });
      this.observer.observe(this,{childList:true,subtree:true});
      this.timer=setTimeout(()=>{if(note?.isConnected)note.textContent='Le formulaire est indisponible. Contactez LAPRIMA au +216 51 680 901.';},15000);
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laprima-pull"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('laprima-pull-section')) {
  customElements.define('laprima-pull-section', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click',event => {
        const button=event.target.closest('[data-pc-photo]');
        if(!button) return;
        const n=Number(button.dataset.pcPhoto);
        this.querySelectorAll('.gal .ph').forEach((p,i)=>p.dataset.pcActive=String(i===n));
        this.querySelectorAll('[data-pc-photo]').forEach((b,i)=>b.setAttribute('aria-current',String(i===n)));
      },{signal:this.controller.signal});
      const note=this.querySelector('.lp-evercore-loading');
      this.observer=new MutationObserver(()=>{
        if(this.querySelector('.evcod-embedded')) {note?.remove();this.observer.disconnect();}
      });
      this.observer.observe(this,{childList:true,subtree:true});
      this.timer=setTimeout(()=>{if(note?.isConnected)note.textContent='Le formulaire est indisponible. Contactez LAPRIMA au +216 51 680 901.';},15000);
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
